import {AfterViewChecked, ChangeDetectorRef, Component, ElementRef, Input, OnDestroy, OnInit, Renderer2} from '@angular/core';
import {Store} from '@ngrx/store';
import * as fromRoot from '../../../../reducers';
import {AuthenticationService} from '../../../../authentication.service';
import {ActivatedRoute, Router} from '@angular/router';
import {GlobalService} from '../../../../global.service';
import {HttpClient, HttpEvent, HttpEventType, HttpResponse} from '@angular/common/http';
import {SeasonsService} from '../../../seasons/seasons.service';
import {MatDialog} from '@angular/material';
import {UsersService} from '../../../users/users.service';
import {DomSanitizer} from '@angular/platform-browser';
import {ImagePopupService} from '../../../../shared/image-popup/image-popup.service';
import {AdSharedServiceService} from '../../../../ad-shared-service.service';

@Component({
  selector: 'elastic-news',
  templateUrl: './news.component.html',
  styleUrls: ['./news.component.scss']
})
export class NewsComponent implements OnInit, AfterViewChecked, OnDestroy {

  @Input()  innerWitdh;

  news = [];

  constructor(
    private store: Store<fromRoot.State>,
    private cd: ChangeDetectorRef,
    private authenticationService: AuthenticationService, private route: ActivatedRoute,
    private router: Router,
    private globalService: GlobalService,
    private http: HttpClient,
    private seasonsService: SeasonsService,
    private dialog: MatDialog,
    private usersService: UsersService,
    private cdr: ChangeDetectorRef,
    private sanitizer: DomSanitizer,
    private imagepopup: ImagePopupService,
    private renderer: Renderer2,
    private el: ElementRef,
    private AdSharedService: AdSharedServiceService
  ) { }

  ngOnInit() {

    this.getData();
    console.log(innerWidth);
  }

  ngAfterViewChecked(): void {
    this.AdSharedService.OnInit(this.el, this.renderer);
  }

  getData() {

    this.globalService.getDashboardNews().subscribe( ( response: HttpEvent<any> ) => {
      switch (response.type) {
        case HttpEventType.Response:
          this.news = response.body.data;

          this.news.forEach( (entry, index) => {
            if (index === 0) {
              entry.open = true;
            }
            entry.text_de = this.sanitizer.bypassSecurityTrustHtml(entry.text_de);
            entry.text_en = this.sanitizer.bypassSecurityTrustHtml(entry.text_en);
          });

          this.cdr.detectChanges();
          console.log(this.news);
          //console.log("USER DATA OBJECT UPDATED!");
          break;
      }

    });

  }

  ngOnDestroy(): void {
    this.AdSharedService.onDestroy(this.el);
  }

}
